import request from '@/utils/request'

const setup = () => {
  return request({
    url: `/api/spinwheel/setup`,
    method: 'get'
  })
}

const spin = () => {
  return request({
    url: `/api/spinwheel/spin`,
    method: 'post'
  })
}

const getCoupon = () => {
  return request({
    url: `/api/spinwheel/coupon`,
    method: 'get'
  })
}

const claimCoupon = coupon => {
  return request({
    url: `/api/spinwheel/coupon/claim`,
    method: 'post',
    data: {
      coupon
    }
  })
}

const isActive = () => {
  return request({
    url: `/api/spinwheel/active`,
    method: 'get'
  })
}

export default {
  setup,
  spin,
  getCoupon,
  claimCoupon,
  isActive
}
